<ng-container>
  <form>
    <mat-form-field class="candidates-chip-list w-100">
      <mat-label>Candidats à ajouter</mat-label>
      <mat-chip-grid #chipGrid aria-label="Candidate selection">
        @for (candidate of selectedCandidates; track candidate) {
        <mat-chip-row class="bg-secondary" (removed)="remove(candidate)">
          {{ candidate.email }}
          <button matChipRemove [attr.aria-label]="'remove ' + candidate.email">
            <span class="material-symbols-outlined fs-6"> close </span>
          </button>
        </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        matInput
        placeholder="Ajouter un candidat..."
        #candidateInput
        [formControl]="CandidateCtrl"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto" />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="candidateSelected($event)">
        @for (candidate of filteredCandidates | async; track candidate) {
        <mat-option [value]="candidate">
          {{ candidate.firstName }} {{ candidate.lastName }} ({{ candidate.email }})
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
</ng-container>
